<template>
  <div
    class="zoom-window"
    :style="`transform: translate(${zoomPosition.x}px, ${zoomPosition.y}px)`"
  >
    <img
      :src="$store.state.assetsPath + backgroundImage"
      alt=""
      :style="`transform: translate(calc(${mousePosition.x}% + 50px + ${mousePositionPolygonPointOffset.x}px), calc(${mousePosition.y}% + 50px + ${mousePositionPolygonPointOffset.y}px))`"
    >
  </div>
</template>

<script>
export default {
  props: ['backgroundImage', 'zoomPosition', 'mousePosition', 'mousePositionPolygonPointOffset']
}
</script>

<style lang="scss" scoped>
.zoom-window {
  background: #fff;
  border: 3px solid #fff;
  border-radius: 50%;
  height: 100px;
  overflow: hidden;
  position: absolute;
  pointer-events: none;
  width: 100px;
  z-index: 100;
  left: 200px;

  &::after {
    align-items: center;
    justify-content: center;
    display: flex;
    color: #fff;
    content: '+';
    font-size: 1em;
    position: absolute;
    top: 0;
    left: 0;
    bottom:0;
    right:0;
    line-height: 0;
  }
}
</style>